import React from "react"

import "./css/custom_range.css"
class SSTWidget extends React.Component {
    state = { 
        internal_value: this.props.roomtemp, 
        value: ((this.props.roomtemp===35)?100:(this.props.roomtemp===30)?62:(this.props.roomtemp===0)?40:(this.props.roomtemp===-10)?20:(this.props.roomtemp===-20)?2:62) ,
        application:this.props.application
    };



    mapValue = (e) => {
        var value = 2;
        var internal_value = -20;
        var application ="Freezer";
        
        if (e.target.value > 62 && e.target.value <= 100) {
            value = 100
            internal_value = 35
            application = "Cooler"
        }
        if (e.target.value > 40 && e.target.value <= 62) {
            value = 62 
            internal_value = 30
            application = "Cooler"
        }
        if (e.target.value > 20 && e.target.value <= 40) {
            value = 40
            internal_value = 0
            application ="Freezer"
        }
        if (e.target.value > 2 && e.target.value <= 20) {
            value = 20
            internal_value = -10
            application ="Freezer"

        }
        if (e.target.value > 0 && e.target.value <= 2) {
            value = 2
            internal_value = -20
            application ="Freezer"

        }
        
        // this.props.update("temp",(application==="Cooler"?"Medium Temp (Cooler)":"Low Temp (Freezer)"))
        this.setState({ value, internal_value ,application})

    }

    componentDidUpdate(prevProps, prevState) {
        // Only call parent callback when user interacted with slider (not when props changed from parent)
        if (prevState.internal_value !== this.state.internal_value && 
            this.state.internal_value !== this.props.roomtemp) {
            this.props.updateRoomtemp(this.state.internal_value, this.state.application);
        }
        
        // Update internal state when roomtemp prop changes from parent
        if (prevProps.roomtemp !== this.props.roomtemp) {
            const newValue = ((this.props.roomtemp===35)?100:(this.props.roomtemp===30)?62:(this.props.roomtemp===0)?40:(this.props.roomtemp===-10)?20:(this.props.roomtemp===-20)?2:62);
            this.setState(prevState => ({
                ...prevState,
                internal_value: this.props.roomtemp,
                value: newValue,
                application: this.props.application
            }));
        }
    }
    
    render() {
        return <div id="slider">
   
            <div >
                <div className="slider_text skyblue S-20F">
                    -20ºF
                </div>
                <div  className="slider_text skyblue S-10F">
                    -10ºF
                </div>
                <div   className="slider_text skyblue S0F">
                    +0ºF
                </div>
                <div  className="slider_text navyblue S30F">
                    +30ºF
                </div>
                {/* <div className="slider_text ash S32F">
                    +32ºF
                </div> */}
                <div className="slider_text navyblue S35F">
                    +35ºF
                </div>

            </div>
            <div className="scalest" >
                <input className="bar" type="range" id="rangeinput"
                    min="0" max="100"
                    value={this.state.value}
                    step="1"
                    onChange={this.mapValue} />
                <div className="highlight">
                    <div className="part1"></div>
                    <div className="part2"></div>
                </div>

            </div>
            <div className="slider-text-container">
                <div className="skyblue bold cooler">
                    Freezer
                </div>
                <div className="navyblue bold">
                    Cooler
                </div>
            </div>

        </div>
    }
}
export default SSTWidget;